<template>
  <div class="articleWrapper">
    <div>Titre</div>
    <input v-model="titre" />
    <button @click="method()">Create</button>
    <vue-editor class="vueEditorFixHeight" v-model="content"></vue-editor>
    <md-button @click="onDelete()" v-if="this.truc && this.truc.ownId">Delete {{warning}}</md-button>
  </div>
</template>

<script>
// @ is an alias to /src
import { VueEditor } from "vue2-editor";
import { mapActions } from "vuex";

export default {
  name: "toolboxEditor",
  props: ["truc"],
  components: {
    VueEditor
  },
  mounted() {
    this.method = this.onToolBoxCreate;
    if (this.truc) {
      this.method = this.onToolBoxUpdate;
      this.content = this.truc.content;
      this.titre = this.truc.title;
    }
  },
  data() {
    return {
      content: "",
      selected: "",
      titre: "",
      selectedCon: "",
      method: null,
      warning: undefined
    };
  },
  methods: {
    ...mapActions(["addToolsBox", "updateToolsBox", "deleteToolsBox"]),
    async onToolBoxCreate() {
      await this.addToolsBox({
        content: this.content,
        title: this.titre
      });
      this.$router.push("/dashboard");
    },
    async onToolBoxUpdate() {
      await this.updateToolsBox({
        ownId: this.truc.ownId,
        data: {
          content: this.content,
          title: this.titre
        }
      });
      this.$router.push("/dashboard");
    },
    onDelete() {
      if (!this.warning) {
        this.warning = "(Click again to confirm deletion)";
        return;
      }
      this.deleteToolsBox(this.truc.ownId);
      this.$router.push("/dashboard");
    }
  }
};
</script>

<style >
#mapid2 {
  height: 500px;
}
.addBtn {
  background-color: white;
  color: black;
  height: 50px;
  margin: 10px;
}
.addBtn:hover {
  cursor: pointer;
}

.articleWrapper {
  background-color: white;
  color: black;
}
</style>
